import ButtonGroup from 'components/ButtonGroup';
import Button from 'components/Button';

import { useEqualisationSection } from './EqualisationContext';
import { Typography } from '@mui/material';
import { round } from 'lodash';

const EqualisationFooter = ({
  handleNext,
  handlePrevious,
  disabled,
  loading,
  tooltipDisabledMessage,
}: {
  handleNext?: () => void;
  handlePrevious?: () => void;
  disabled: boolean;
  loading: boolean;
  tooltipDisabledMessage?: string;
}) => {
  const { previousSection, sections, currentSection } =
    useEqualisationSection();

  const percentageOfSections = round(
    (sections.indexOf(currentSection) / sections.length) * 100,
    2,
  );

  return (
    <ButtonGroup sx={{ marginTop: 2 }}>
      {previousSection && (
        <Button variant="outlined" onClick={handlePrevious} loading={loading}>
          Previous
        </Button>
      )}
      <Button
        variant="contained"
        color="primary"
        onClick={handleNext}
        disabled={disabled}
        loading={loading}
        tooltip={
          disabled
            ? tooltipDisabledMessage ??
              'Please ensure that the total expense in the allocation equals the action amount.'
            : undefined
        }
      >
        Approve & next
      </Button>
      <Typography variant="body1" color="text.secondary">
        {percentageOfSections}%
      </Typography>
    </ButtonGroup>
  );
};

export default EqualisationFooter;
